// extracted by mini-css-extract-plugin
export default {"waikawaGray":"#666","black":"#000","body":"collapsible_body__fqgZT","section":"collapsible_section__oslx-"};